import { render, staticRenderFns } from "./EntityAutomationBlock.vue?vue&type=template&id=588e3771&scoped=true"
import script from "./EntityAutomationBlock.vue?vue&type=script&lang=js"
export * from "./EntityAutomationBlock.vue?vue&type=script&lang=js"
import style0 from "./EntityAutomationBlock.vue?vue&type=style&index=0&id=588e3771&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e3771",
  null
  
)

export default component.exports